export default __webpack_public_path__ + "static/media/Aris.ed914fb3.png";